__turbopack_context__.v({
  "label": "mantinePill-module-scss-module__FP6Zra__label",
  "root": "mantinePill-module-scss-module__FP6Zra__root",
});
